import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';
import {CmsNotificationContainerModel} from '../../../../../../models';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class CmsPushNotificationService extends BaseApiTemplateService<CmsNotificationContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'notifications/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'notifications/backoffice-ep';
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'notifications/' + Core2Config.PUBLIC_EP_SUFFIX;
    this.httpClient = http;
  }

  publishNotification(request: CmsNotificationContainerModel, websiteCode: string, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'notifications/publish/backoffice-ep';
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'notifications/publish/backoffice-ep';
    if (apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + endpoint_path;
    }

    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode : '';

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code,
        websiteCode: websiteCode
      })
    };

    return this.httpClient.post<BasicApiResponseModel<any>>(
      apiUrl,
      request,
      httpOptions
    );
  }
}